module.exports = __webpack_public_path__ + "assets/img/smartProductBg4.0674ef4e.png";